import { jsx as r } from "../../../../../external/preact/jsx-runtime/dist/jsxRuntime.module.js";
import u from "../PreQualifiedIntro.js";
import { useState as d, useCallback as n, useMemo as h } from "../../../../../external/preact/hooks/dist/hooks.module.js";
import { CapitalOffer as C } from "../../../CapitalOffer/components/CapitalOffer/CapitalOffer.js";
import { Fragment as g } from "../../../../../external/preact/dist/preact.module.js";
const q = ({
  hideTitle: f,
  dynamicOffer: o,
  skipPreQualifiedIntro: e,
  onOfferOptionsRequest: a,
  onFundsRequest: s,
  onOfferDismiss: t
}) => {
  const [m, i] = d(e ? "capitalOffer" : "intro"), c = n(() => {
    a ? a() : i("capitalOffer");
  }, [a]), l = h(() => !e || !!t, [t, e]), p = n(() => {
    t ? t() : i("intro");
  }, [t]);
  return /* @__PURE__ */ r(g, { children: m === "intro" ? /* @__PURE__ */ r(u, { hideTitle: f, dynamicOfferConfig: o, onOfferOptionsRequest: c }) : /* @__PURE__ */ r(
    C,
    {
      onFundsRequest: s,
      onOfferDismiss: l ? p : void 0,
      externalDynamicOffersConfig: o
    }
  ) });
};
export {
  q as PreQualified
};
